import { render, staticRenderFns } from "./TablePagination.vue?vue&type=template&id=2203a74e&"
import script from "./TablePagination.vue?vue&type=script&lang=ts&"
export * from "./TablePagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2203a74e')) {
      api.createRecord('2203a74e', component.options)
    } else {
      api.reload('2203a74e', component.options)
    }
    module.hot.accept("./TablePagination.vue?vue&type=template&id=2203a74e&", function () {
      api.rerender('2203a74e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/TablePagination.vue"
export default component.exports